import { Calculator as CalculatorIcon, PiggyBank as PiggyBankIcon, Star as StarIcon } from "@tamagui/lucide-icons";
import type { IntakeLandingHero } from "../../components/intake";
import { pregnancyHeroImage } from "../natera-intake/landingHero";
import { landing } from "./copy";
export const routingHero: IntakeLandingHero = {
  image: pregnancyHeroImage,
  headline: landing.headline,
  stats: [{
    ...landing.stats.upfront,
    icon: <CalculatorIcon size="$iconSmall" color="$iconInverse" />
  }, {
    ...landing.stats.savings,
    icon: <PiggyBankIcon size="$iconSmall" color="$iconInverse" />
  }, {
    ...landing.stats.rating,
    icon: <StarIcon size="$iconSmall" color="$iconInverse" fill="currentColor" />
  }],
  trust: landing.trust
};